// extracted by mini-css-extract-plugin
export default {"date":"AcnkPkU0P0Rm1Rfn_oKE","StatsAppointmentsStatus":"cj9pIX1DEIOC5iDg1nXm"};